/* Every page of the app as a route id. Used by content checks (lesson "go" links) and e2e tests. */
import { FACTS, factRoute } from '../content/facts';
import { LESSONS } from '../content/lessons';
import { SONGS } from '../content/songs';
import { MODULE_DEFS } from './registry';

export const STATIC_ROUTES = [
  'ana',
  'gitar',
  'gitar.antrenman',
  'gitar.meydan',
  'nota',
  'nota.antrenman',
  'nota.kesfet',
  'nota.meydan',
  'vokal',
  'vokal.antrenman',
  'vokal.rutin',
  'vokal.aralik-testi',
  'vokal.isinma',
  'akor',
  'akor.antrenman',
  'akor.sarkilar',
  'akor.meydan',
  'jam',
  'araclar',
  'araclar.akort',
  'araclar.metronom',
  'araclar.kutuphane',
  'araclar.analiz',
  'az-bilinenler',
  'ilerleme',
  'ayarlar',
  'yenilikler',
] as const;

export interface RouteIndex {
  pages: string[];
  lessons: { route: string; blocks: number }[];
  levels: string[];
  challenges: string[];
  songs: string[];
  /** one Jam game per song */
  jam: string[];
  facts: { route: string; blocks: number }[];
}

export function routeIndex(): RouteIndex {
  return {
    pages: [...STATIC_ROUTES],
    lessons: Object.entries(LESSONS).flatMap(([m, list]) =>
      list.map((l) => ({ route: `${m}.ders.${l.id}`, blocks: l.blocks.length })),
    ),
    levels: Object.values(MODULE_DEFS).flatMap((d) => d.levels.map((l) => l.route)),
    challenges: Object.values(MODULE_DEFS).flatMap((d) => d.challenges.map((c) => c.route)),
    songs: SONGS.flatMap((s) => [`akor.sarki.${s.id}`, `akor.sarki.${s.id}.birlikte`]),
    jam: SONGS.map((s) => `jam.${s.id}`),
    facts: FACTS.map((f) => ({ route: factRoute(f), blocks: f.blocks.length })),
  };
}

export function allRoutes(): Set<string> {
  const r = routeIndex();
  return new Set([
    ...r.pages,
    ...r.lessons.map((l) => l.route),
    ...r.levels,
    ...r.challenges,
    ...r.songs,
    ...r.jam,
    ...r.facts.map((f) => f.route),
  ]);
}
